






















































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {LoginState} from "../../store/modules/user";
import firebase from "firebase";
import LoginManager from "../../script/login";
import {helpers, maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

const emailValidator = helpers.regex(
    "emailValidator",
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
);

@Component({
    components: {},
    mixins: [validationMixin],
    validations: {
        form: {
            email: {
                required,
                emailValidator,
            },
            username: {
                required,
                maxLength: maxLength(12),
            },
            // nickname: {
            //     required,
            //     maxLength: maxLength(20),
            // },
        },
    },
})
export default class Login extends Vue {
    private form = {
        email: "",
        username: "",
        // nickname: "",
        policyAgreement1: false
    };
    isEmailReadOnly = false;
    isNameReadOnly = false;

    errorAgree1 = false
    allAgreement = false

    async mounted() {
        const loginState = await this.$store.dispatch("loginState");
        switch (loginState) {
            case LoginState.login:
                await this.$router.replace("/").catch(() => {
                });
                return;
        }
        const currentUser = firebase.auth().currentUser;

        if (!currentUser) {
            await this.$router.replace('/login');
            return;
        }
        this.form.email = currentUser.email as string;
        this.form.username = currentUser.displayName as string;
    }


    beforeDestroy() {
        this.isEmailReadOnly = false;
        this.isNameReadOnly = false;
    }

    // vuelidate
    validateState(name) {
        const {$dirty, $error} = this.$v.form[name]!;
        return $dirty ? !$error : null;
    }

    async register(event) {
        event.preventDefault();
        this.$v.form.$touch();
        let isReturn = false;
        if (this.$v.form.$anyError) {
            isReturn = true;
        }
        if (!this.form.policyAgreement1) {
            isReturn = true;
            this.errorAgree1 = true;
        }
        if (isReturn) return;

        const obj={
            name:this.form.username,
            // nickname:this.form.nickname
        }
        const result = await this.$api.signUp(obj);

        if (!result || result.error) {
            // if (result && result.error && result.error.message === '사용할 수 없는 단어') {
            if (result?.error?.code === 40101) {
                alert(`${this.$t('name.err.text')}`);
                // todo 닉네임 필터 에러 처리
                // alert(this.$t('join.joinNicknameError'));
            }
            else {
                console.error((result && result.error) || "error");
                result && result.error && alert(result.error.message);
            }
        }
        else {
            const {user} = result;
            this.$store.commit("user", user);
            await LoginManager.login();
            // await this.$router.replace('/');

            if (this.$store.getters.redirectRouter) {
                const router = this.$store.getters.redirectRouter;
                this.$store.commit("redirectRouter", null);
                await this.$router.replace(router).catch(() => {
                });
            }
            else if (this.$store.getters.redirectUrl) {
                const url = this.$store.getters.redirectUrl;
                this.$store.commit("redirectUrl", null);
                window.location.href = url;
            }
            else {
                await this.$router.replace("/").catch(() => {
                });
            }
        }

    }


    agreement1() {
        if (this.form.policyAgreement1) {
            this.errorAgree1 = true;
        }
        else {
            this.errorAgree1 = false;
        }


    }

    allAgree() {
        if (this.allAgreement) {
            this.form.policyAgreement1 = false;
            // this.form.policyAgreement2 = false;
            this.errorAgree1 = true;
            // this.errorAgree2 = true;
        }
        else {
            this.form.policyAgreement1 = true;
            // this.form.policyAgreement2 = true;
            this.errorAgree1 = false;
            // this.errorAgree2 = false;
        }


    }


}
